import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const EquatorialGuineaFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14817'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14817)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#EC3938'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#51B422'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.7184 8.20057C9.73972 8.17881 9.75173 8.14961 9.75191 8.11916L9.75995 6.74126C9.76062 6.62661 9.66786 6.53331 9.55321 6.53331C9.36801 6.53331 9.27624 6.30853 9.40851 6.17891L9.76595 5.82862C9.89556 5.7016 10.103 5.7016 10.2326 5.82862L10.5894 6.17831C10.7219 6.30815 10.63 6.53331 10.4444 6.53331C10.3301 6.53331 10.2374 6.62603 10.2374 6.7404V8.11783C10.2374 8.14905 10.2499 8.17896 10.2722 8.20081C10.3465 8.27366 10.295 8.39998 10.1909 8.39998H9.80221C9.69828 8.39998 9.64567 8.27481 9.7184 8.20057Z'
					fill='#159940'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 0L6.66667 7L0 14V0Z'
					fill='#258DE7'
				/>
			</g>
		</svg>
	);
};

export default EquatorialGuineaFlagIcon;
